import React, { useState, useEffect } from "react";
import { MenuItem, Select, Box } from "@mui/material";


import TotalFramesChart from "../Components/Charts/TotalFramesChart";
import AveragePeopleChart from "../Components/Charts/AveragePeopleChart";
import AverageMaleChart from "../Components/Charts/AverageMaleChart";
import AverageFemaleChart from "../Components/Charts/AverageFemaleChart";
import AverageFemaleWeekdayChart from "../Components/Charts/AverageFemaleWeekdayChart";
import AverageMaleWeekdayChart from "../Components/Charts/AverageMaleWeekdayChart";
import BusiestHourChart from "../Components/Charts/BusiestHourChart";
import AveragePersonsByFloor from "../Components/Charts/AveragePersonsByFloor";
import AveragePersonsByFloorAndWeekday from "../Components/Charts/AveragePersonsByFloorAndWeekday";
import AveragePersonsByFloorAndHour from "../Components/Charts/AveragePersonsByFloorAndHour";
import CameraFrameComparisonChart from "../Components/Charts/CameraFrameComparisonChart";
import ThresholdViolationsByCameraChart from "../Components/Charts/ThresholdViolationsByCameraChart";
import FireDetectionsByCameraChart from "../Components/Charts/FireDetectionsByCameraChart";
const charts = {

  // UniqueCamerasPie: <UniqueCamerasPie />,
  TotalFramesChart: <TotalFramesChart />,
  AveragePeopleChart: <AveragePeopleChart />,
  AverageMaleChart: <AverageMaleChart />,
  AverageFemaleChart : <AverageFemaleChart />,
  AverageMaleWeekdayChart: <AverageMaleWeekdayChart />,
  AverageFemaleWeekdayChart: <AverageFemaleWeekdayChart />,
  BusiestHourChart: <BusiestHourChart/>,
  AveragePersonsByFloor: <AveragePersonsByFloor/>,
  AveragePersonsByFloorAndWeekday: <AveragePersonsByFloorAndWeekday/>,
  AveragePersonsByFloorAndHour:<AveragePersonsByFloorAndHour/>,
  CameraFrameComparisonChart:<CameraFrameComparisonChart/>,
  ThresholdViolationsByCameraChart:<ThresholdViolationsByCameraChart/>,
  FireDetectionsByCameraChart:<FireDetectionsByCameraChart/>
};

const Charts = () => {
  const [selectedChart, setSelectedChart] = useState("TotalFramesChart");

  return (
    <Box
      sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      width: "100%",
    }}
    >
          
            <Select
             sx={{
                  width: "50%",
                }}
            value={selectedChart}
            onChange={(e) => setSelectedChart(e.target.value)}
          >
            <MenuItem value="TotalFramesChart">Total Frames Chart</MenuItem>
            <MenuItem value="AveragePeopleChart">Average People Chart</MenuItem>
            <MenuItem value="AverageMaleChart">Average Male Chart</MenuItem>
            <MenuItem value="AverageFemaleChart">Average Female Chart</MenuItem>
            <MenuItem value="AverageMaleWeekdayChart">Average Male Weekday Chart</MenuItem>
            <MenuItem value="AverageFemaleWeekdayChart">Average Female Weekday Chart</MenuItem>
            <MenuItem value="BusiestHourChart">Busiest Hour Chart</MenuItem>
            <MenuItem value="AveragePersonsByFloor">Average Persons By Floor Chart</MenuItem>
            <MenuItem value="AveragePersonsByFloorAndWeekday">Average Persons By Floor And Weekday Chart</MenuItem>
            <MenuItem value="AveragePersonsByFloorAndHour">Average Persons By Floor And Hour Chart</MenuItem>
            <MenuItem value="CameraFrameComparisonChart">Camera Frame Comparison Chart</MenuItem>
            <MenuItem value="ThresholdViolationsByCameraChart">Threshold Violations By Camera Chart</MenuItem>
            <MenuItem value="FireDetectionsByCameraChart">Fire Detections By Camera Chart</MenuItem>
          </Select>
          
    
     

       <Box 
        sx={{
                  width: "100%",
                  marginTop: "20px",
                }}
          >
        {React.cloneElement(charts[selectedChart])}
      </Box>
    </Box>
  );
};

export default Charts;
